import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios';
import { review_reviewList } from "../../sample-data";

const initialState = {
  data: [],
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;

export const fetchCommentRegStatus = createAsyncThunk(
  "CommentRegStatus/fetchCommentRegStatus",
  async (thunkApi, { rejectWithValue }) => {    
    await new Promise(resolve => setTimeout(resolve, 200));
    return review_reviewList;
    try {
      const response = await axios.get(url, {
        validateStatus: status => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceCommentRegStatus = createSlice({
  name: "CommentRegStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommentRegStatus.pending, (state) => {
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(fetchCommentRegStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = ""; // Reset error on successful fetch
      })
      .addCase(fetchCommentRegStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        console.log(state.error);
      });
  },
});

export const selectCommentRegStatusData = (state) => state.CommentRegStatus.data;
export const selectIsLoading = (state) => state.CommentRegStatus.isLoading;
export const selectError = (state) => state.CommentRegStatus.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.CommentRegStatus.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.CommentRegStatus.data,
  isLoading: state.CommentRegStatus.isLoading,
  error: state.CommentRegStatus.error,
}));
*/
export default sliceCommentRegStatus.reducer; // Export the reducer
